module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v("ALSO BY ELIZABETH ADLER")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("One of Those Malibu Nights")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Meet Me in Venice")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Sailing to Capri")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The House in Amalfi")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Invitation to Provence")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Hotel Riviera")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Summer in Tuscany")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Last Time I Saw Paris")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("In a Heartbeat")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Sooner or Later")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("All or Nothing")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Now or Never")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Fleeting Images")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Indiscretions")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Heiress")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Secret of Villa Mimosa")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Legacy of Secrets")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Fortune Is a Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Property of a Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("The Rich Shall Inherit")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Peach")])]), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('em', [_vm._v("Léonie")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a088458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter.vue
// module id = 60
// module chunks = 0